// extracted by mini-css-extract-plugin
export default {"root":"_2_k0N","llama":"fpvn4","big":"_20Maf","small":"hwqCJ"};